import React, { FC, memo } from 'react';
import classNames from 'classnames';

import type { ReportSelectionHeaderAction, ReportSelectionHeaderProps } from './types';

import styles from './index.module.scss';

const ReportSelectionHeader: FC<ReportSelectionHeaderProps> = ({
  actionsDividerTestId,
  actionsTestId,
  className,
  isMobileStacked = false,
  resetAction,
  selectAllAction,
  selectedCount,
  selectedCountTestId,
  testId,
}) => {
  const actions = [selectAllAction, resetAction].filter((action): action is ReportSelectionHeaderAction =>
    Boolean(action)
  );

  return (
    <div
      className={classNames(styles.header, className, {
        [styles.headerMobileStacked]: isMobileStacked,
      })}
      data-testid={testId}>
      <span
        className={styles.selectedCount}
        data-testid={selectedCountTestId}>
        {selectedCount}
      </span>

      {actions.length > 0 && (
        <div
          className={styles.actions}
          data-testid={actionsTestId}>
          {actions.map((action, index) => (
            <React.Fragment key={action.testId}>
              {index > 0 && (
                <span
                  className={styles.actionsDivider}
                  data-testid={actionsDividerTestId}>
                  •
                </span>
              )}
              <button
                type="button"
                className={styles.actionButton}
                data-testid={action.testId}
                disabled={action.isDisabled}
                onClick={action.onClick}>
                {action.text}
              </button>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(ReportSelectionHeader);
